export default __webpack_public_path__ + "static/media/rangeFair.d56404ed.svg";